import { message } from "antd";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../hooks/auth";
import { IClient } from "../../pages/Clients";
import { api } from "../../services/api";
import { Load } from "../Load";
import { Content } from "./styles";


export function MessagesCountBar({ ...rest }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(0);
  const [percentage, setPercentage] = useState(0);
  function fetchUserData() {
    api
      .get<{ total: number; used: string }>(`users/limit/${user.id}`)
      .then((response) => {
        const { total, used } = response.data;
        setTotal(Number(used));
        setLimit(total);
      })
      .catch((e) => {
        message.error(e.response.data.message);
      })
      .finally(() => setLoading(false));
  }
  function fetchClientData() {
    api
      .get<IClient>(`users/limit/${user.id}`)
      .then((response) => {
        const { messageCount, messageLimit } = response.data;
        setTotal(Number(messageCount));
        setLimit(messageLimit);
      })
      .catch((e) => {
        message.error(e.response.data.message);
      })
      .finally(() => setLoading(false));
  }
  function fetchData() {
    return user.type === 'USER' ? fetchUserData() : fetchClientData()
 
  }
  useEffect(fetchData, []);
  useEffect(() => {
    setPercentage(Math.ceil((total / limit) * 100));
  }, [total, limit]);
  return (
    <Content percentage={percentage}>
      {loading ? (
        <div className="loading">
          <Load />
        </div>
      ) : (
        <>
          <div className="parcentage-info">
            <span className="title">Mensagens contratadas</span>
            <span className="text">
              {total}/{limit}
            </span>
            <div className="percentage-bar">
              <div className="total-bar"></div>
              <div className="active-bar"></div>
            </div>
          </div>
          <div className="percentage">{percentage}%</div>
        </>
      )}
    </Content>
  );
}
